import { render, staticRenderFns } from "./DomainAlias.vue?vue&type=template&id=820fbc14&"
import script from "./DomainAlias.vue?vue&type=script&lang=js&"
export * from "./DomainAlias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports